// extracted by mini-css-extract-plugin
export var modal = "_mg-0";